import { render, staticRenderFns } from "./ImproveLabelAccuracyModal.vue?vue&type=template&id=639e22dc&scoped=true&"
import script from "./ImproveLabelAccuracyModal.vue?vue&type=script&lang=ts&"
export * from "./ImproveLabelAccuracyModal.vue?vue&type=script&lang=ts&"
import style0 from "./ImproveLabelAccuracyModal.vue?vue&type=style&index=0&id=639e22dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639e22dc",
  null
  
)

export default component.exports